import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  Button,
  FieldError,
  Form,
  Input,
  Label,
  Modal,
  TextField,
} from "@heroui/react";
import { Icon } from "@iconify/react";

import { useCreateCity } from "@/features/city/use-cities.ts";

interface IFormInput {
  name: string;
}

export function CreateCityModal() {
  const [isOpen, setIsOpen] = useState(false);

  const createCityMutation = useCreateCity();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    createCityMutation
      .mutateAsync({
        name: data.name.trim(),
        country: "KZ",
      })
      .then(() => {
        reset();
        setIsOpen(false);
      });
  };

  return (
    <div>
      <Button
        variant="primary"
        onPress={() => setIsOpen(true)}
      >
        Создать
        <Icon className="size-6" icon="solar:add-circle-bold" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Header>
                  <Modal.Heading>Создать новый город</Modal.Heading>
                </Modal.Header>
                <Modal.Body>
                  <TextField isInvalid={!!errors.name?.message}>
                    <Label>Название города</Label>
                    <Input
                        placeholder="Введите название города"
                        {...register("name", { required: "Нужно заполнить поле" })}
                    />
                    <FieldError>{errors.name?.message}</FieldError>
                  </TextField>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                      variant="danger-soft"
                      onPress={() => setIsOpen(false)}
                  >
                    Отмена
                  </Button>

                  <Button
                      variant="primary"
                      isPending={createCityMutation.isPending}
                      type="submit"
                  >
                    Создать
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
